import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Import slider images
import slide1 from "../../images/slider/s1.webp";
import slide3 from "../../images/slider/s3.webp";
import slide4 from "../../images/slider/s4.webp";
import slide6 from "../../images/slider/s6.webp";

const Hero = () => {
  // Slider settings using existing project style with responsive options
  const heroSliderSettings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          fade: false,
          cssEase: "ease",
        },
      },
      {
        breakpoint: 767,
        settings: {
          fade: false,
          cssEase: "ease",
          speed: 500,
        },
      },
    ],
  };

  // Slide data
  const slides = [
    {
      id: 1,
      icon: "flaticon-graduation-cap",
      title: "Mentorship That Scales",
      headline: "Join India's Biggest Cash Flow Summit-April 2026, New Delhi",
      subline:
        "Connect with industry leaders, learn from real success stories, and get hands-on tools to transform your business finances at India's premier cash flow event.",
      image: slide4,
    },
    {
      id: 2,
      icon: "ti-check",
      title: "From Stress to Stability",
      headline: "Your Bussiness doesn't need more hustle-it need a system",
      subline:
        "Replace endless hustle with automated systems. Build predictable cash flow that works even when you're not working.",
      image: slide6,
    },
    {
      id: 3,
      icon: "ti-settings",
      title: "Power of Systems",
      headline: "Turn your profits into freedom-not pressure",
      subline:
        "Transform your business from profit-chasing to freedom-building. Create systems that generate cash flow automatically, giving you time and peace of mind.",
      image: slide3,
    },
    {
      id: 4,
      icon: "ti-light-bulb",
      title: "Profit is a Number, Cash Flow is Lifeline",
      headline: "Late Payments Chocking Your Growth",
      subline:
        "Stop waiting for payments. Learn proven strategies to get paid faster and maintain healthy cash flow that keeps your business thriving.",
      image: slide1,
    },
  ];

  return (
    <section className="hero-slide">
      <Slider {...heroSliderSettings} className="hero-slider-main">
        {slides.map((slide) => (
          <div key={slide.id} className="hero-slider-section">
            <div className="hero-bg">
              <img src={slide.image} alt={slide.title} />
            </div>
            <div className="container-fluid">
              <div className="content">
                <div className="title">
                  <div className="icon">
                    <i className={slide.icon}></i>
                  </div>
                  <span>{slide.title}</span>
                </div>
                <div className="sub-title">
                  <h2>
                    {slide.headline.split(" — ").map((part, index) => (
                      <React.Fragment key={index}>
                        {part}
                        {index < slide.headline.split(" — ").length - 1 && (
                          <>
                            {" — "}
                            <br />
                          </>
                        )}
                      </React.Fragment>
                    ))}
                  </h2>
                </div>
                <p>{slide.subline}</p>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
};

export default Hero;
